module.exports = {
  environment: "alkqaaws",
  ssoUrl: "https://authws-qa.alk.com/api/",
  fleetPortalUrl: "https://api-copilotfleetportal-qa.alk.com/",
  daUrl: "https://dataanywhere-qa.alk.com/api/",
  pcmwsUrl: "https://pcmiler-aws-qa.alk.com/APIs/REST/v1.0/service.svc/",
  alkmapsUrl: "//maps-aws-qa.alk.com/api/1.2/ALKMaps.js",
  alkiconsUrl: "https://d1azc1qln24ryf.cloudfront.net/104959/ALKIcons/style-cf.css?8hwqaj",
  alkmapsApiKey: "48667533B12E8942B038B8533A35F4A5",
  fleetViewUrl: "https://api-copilotroutereporter-qa.alk.com/",
  routeReporterUrl: "https://routereporter-export-qa.trimblemaps.com/",
  partnerApplicationName: "CoPilot FleetView",
  applicationName: "CoPilot FleetView",
  hubspotPortalId: "4239221",
  hubspotFormId: "d524628a-c40f-4d1c-bf59-cabcf276fffc",
  newRRWeb: "https://routereporter-qa.trimblemaps.com/",
  trimbleApplication: "Route_Reporter--dev-qa",
  trimbleCloudClientId: "117942a5-d3f3-46bb-943b-5d56969dd86f",
  tidClientSecret: "79c06d97ac604cc89040a8b8628d406d",
  trimbleCloudUrl:"https://stage.id.trimblecloud.com/"
};



// WEBPACK FOOTER //
// ./config/alkqaaws.js